import {useEffect, useState} from 'react';
import './App.css';
import {useAuth0} from '@auth0/auth0-react';
import {addAccessTokenInterceptor} from './API/axiosClient';
import {ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import SalvoContextProvider from './contexts/SalvoContextProvider';
import ViewAsComponent from "./components/ViewAsComponent";
import ConditionalRender from "./components/ConditionalRender";
import VerticalNavigation from "./components/core/Navigation/VerticalNavigation";
import AppRoutes from "./pages/AppRoutes";
import CurrentEnvironmentDisplay from "./components/CurrentEnvironmentDisplay";
import BannerComponent from 'components/BannerComponent';

function App() {

  const { isLoading: auth0Loading, getAccessTokenSilently, isAuthenticated, loginWithRedirect} = useAuth0()
  const [interceptorAdded, setInterceptorAdded] = useState(false);

  useEffect(() => {
    if(!auth0Loading)
    {
       //Auth0 has finished loading.
       if(isAuthenticated)
       {
         //User is authenticated, but the interceptor has not been added yet.
         if(!interceptorAdded)
         {
           addAccessTokenInterceptor(getAccessTokenSilently);
           setInterceptorAdded(true)
         }
       }
       else {
          //User is not authenticated, redirect to login.
          loginWithRedirect({appState: { returnTo: window.location.pathname}})
       }
    }
  }, [getAccessTokenSilently, auth0Loading, interceptorAdded, isAuthenticated, loginWithRedirect]);

  // const { isLoaded } = useJsApiLoader({
  //   id: 'google-map-script',
  //   googleMapsApiKey: "AIzaSyCZult5Wi6jfRx2pMQjMXmCHewmv2O8fD4",
  //   libraries
  // });

  return (
    <div className="App">
      <ConditionalRender condition={interceptorAdded} showLoading pageLoader>
        <SalvoContextProvider>
          <ToastContainer limit={6} pauseOnFocusLoss={false} pauseOnHover={false} />
          <div className={'d-flex'}>
            <VerticalNavigation/>
            <main className={'flex-grow-1'} style={{marginLeft: 230}}> {/* 230px is the width of the vertical navigation */}
              <CurrentEnvironmentDisplay/>
              <ViewAsComponent/>
              <BannerComponent/>
              <div className='p-3'>
                <AppRoutes/>
              </div>
            </main>
          </div>
        </SalvoContextProvider>
      </ConditionalRender>
    </div> 
  );
}

export default App;
